/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Card_Access_ErrorInputs */



/**
* | output |
* | --- |
* | "Card Access Error" |
*
* @param {Sanction_Sub_Card_Access_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_card_access_error = /** @type {((inputs?: Sanction_Sub_Card_Access_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Card_Access_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur d'Accès aux Cartes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de Acceso a Cartas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de Acesso a Cartas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di Accesso alle Carte")
	return /** @type {LocalizedString} */ ("Card Access Error")
});